export default (state, action) => ({
  ...state,
  selectedEstimate: action.payload.designId,
});
